<template>
    <v-skeleton-loader v-if="isLoading" type="text@2" />
    <div v-else-if="items?.length">
        <div v-for="item in items" :key="item.channelManager">
            <v-text-field
                v-model="item.externalId"
                :label="$t(`channelManagersLabel.${item.channelManager}`)"
                :data-cy="item.channelManager"
                class="input-w-big"
                variant="outlined"
                density="compact"
            />
        </div>
    </div>
    <div v-else>
        {{ $t('no_data') }}
    </div>
</template>
<script setup lang="ts">
    interface ChannelManagerConfig {
        channelManager?: string
        externalId?: string
    }

    interface Props {
        isLoading?: boolean
    }
    defineProps<Props>()

    const items = defineModel<ChannelManagerConfig[]>()
</script>
